import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';

/**
 * Create/edit editor for a transaction fee - a named value attached to a fee type,
 * shown as a line when transaction totals are broken down.
 */
@Component({
    selector: 'app-edittransactionfee',
    templateUrl: './edittransactionfee.component.html',
    standalone: false
})
export class EdittransactionfeeComponent extends ModelEditor {

  public FeeTypes: any[] | null = null;

  constructor(private injector: Injector) {
    super("payments/transactionbreakdown/fees", injector);
    this.api.Get<any[]>("payments/transactionbreakdown/feetypes").then(result => this.FeeTypes = result);
  }

  public override DefaultModel(): any {
    return {
      DisplayName: "",
      Value: 0,
      TransactionFeeTypeId: null,
      Active: true
    };
  }

  public override AfterModelLoaded(): void {
  }

  public override BeforeSave(): boolean | void {
  }

  public override Validators(): any {
    return {
      "DisplayName": [Validators.required],
      "TransactionFeeTypeId": [Validators.required]
    };
  }

  /**
   * The currently selected fee type, used to adapt the Value field between percentage and flat amount.
   */
  public SelectedFeeType(): any | null {
    let id = this.Form.get('TransactionFeeTypeId')?.value;
    return this.FeeTypes?.find(x => x.Id == id) ?? null;
  }
}
